import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import DetaljKommentarer from "../Common/Detalj/DetaljKommentarer";
import GridTable from "../Common/GridTable";
import Tabs from "../Common/Tabs";
import BilderAndObservasjonsbilderContainer from "./BilderAndObservasjonsbilderContainer";
import BilderContainer from "./BilderContainer";
import TilbakemeldingerFraBybetjenter from "./TilbakeMeldingerFraBybetjent";

import sitePaths from "../../constants/sitePaths";
import getGridDataForKlageIleggelseDetail from "../../selectors/klageIeggelseDetailSelector";
import getGridDataForKlageMiljogebyrDetail from "../../selectors/klageMiljogebyrDetailSelector";

import { getInternkoderIleggelser } from "../../actions/internkoderIleggelserActions";
import { getInternkoderMiljogebyr } from "../../actions/internkoderMiljogebyrActions";
import { getMottakertyper } from "../../actions/mottakertyperActions";
import { getOvertredelserkoderIleggelser } from "../../actions/overtredelseskoderIleggelserActions";
import { getOvertredelseskoderMiljogebyr } from "../../actions/overtredelseskoderMiljogebyrActions";

function IleggelseDetailTabsContainer({ isThumbAndLightboxImg, ileggelsesType }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const klageIleggelse = useSelector((state) => state.klageIleggelse);
  const gridDataForKlageIleggelseDetail = useSelector((state) =>
    getGridDataForKlageIleggelseDetail(state)
  );
  const gridDataForKlageMiljogebyrDetail = useSelector((state) =>
    getGridDataForKlageMiljogebyrDetail(state)
  );
  const ileggelseRettelser = useSelector((state) => state.ileggelseRettelser);
  const miljoRettelser = useSelector((state) => state.miljoRettelser);

  const [selectedTab, setSelectedTab] = useState(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    dispatch(getOvertredelserkoderIleggelser());
    dispatch(getOvertredelseskoderMiljogebyr());
    dispatch(getInternkoderIleggelser());
    dispatch(getInternkoderMiljogebyr());
    dispatch(getMottakertyper());
  }, []);

  const isMiljogebyr = () => ileggelsesType === "M";

  const getGridData = () => {
    return isMiljogebyr()
      ? gridDataForKlageMiljogebyrDetail
      : gridDataForKlageIleggelseDetail;
  };

  const tilbakemeldinger = () => {
    return isMiljogebyr() ? miljoRettelser : ileggelseRettelser;
  };

  const onSelectTab = (tabIndex) => {
    setSelectedTab(tabIndex);
    if (tabIndex === "2") {
      const detaljUrl = isMiljogebyr()
        ? sitePaths.klage.miljogebyrer.shortUrl + "/" + klageIleggelse.id
        : sitePaths.klage.ileggelser.shortUrl + "/" + klageIleggelse.id;
      navigate(detaljUrl);
    }
  };

  const klageDetailTabsTitle = ["Detaljer", "Bilder", "Se flere detaljer"];
  const tilbakemeldingerData = tilbakemeldinger();

  return (
    <div className="klageIleggelseDetaljer">
      <Tabs
        titles={klageDetailTabsTitle}
        bsClass="noboarderStyle"
        selectedTab={selectedTab}
        onSelectTab={onSelectTab}
      >
        <div key="Detaljer">
          <GridTable
            name="klageDetailGridTable"
            rows={getGridData()}
            oneColoredGridTable
          />
          <DetaljKommentarer
            internkommentarFraBybetjent={klageIleggelse.internkommentar}
            kommentarTilMottager={klageIleggelse.kommentar}
          />
          <div style={{ marginTop: 20 }} />
          <TilbakemeldingerFraBybetjenter
            tilbakemeldinger={tilbakemeldingerData}
          />
        </div>
        <div key="Bilder">
          {klageIleggelse && !klageIleggelse.miljoKontrollId && (
            <BilderContainer isThumbAndLightboxImg={isThumbAndLightboxImg} />
          )}
          {klageIleggelse && klageIleggelse.miljoKontrollId && (
            <BilderAndObservasjonsbilderContainer />
          )}
        </div>
      </Tabs>
    </div>
  );
}

IleggelseDetailTabsContainer.propTypes = {
  isThumbAndLightboxImg: PropTypes.bool,
  ileggelsesType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default IleggelseDetailTabsContainer;
